import React, { useState, useEffect } from 'react'
import classnames from 'classnames'

import RadioButton from '../../../components/radioButton'

export const CoverageProtectionCheckBox = ({
  value,
  changeSelected,
  subsectionId,
  selected,
  disabled = false,
}) => {
  return (
    <div className="payment-options-checkbox">
      <RadioButton
        iconSize="20px"
        value={value}
        name={`${subsectionId}-${value}-${1}`}
        uid={`${subsectionId}-${value}-${1}`}
        onClick={(data) => changeSelected(data)}
        onChange={() => null}
        checked={selected}
        disabled={disabled}
      />
      <label htmlFor={`${value}-${1}`} />
      {value}
    </div>
  )
}

const CoverageSurchargeFilterList = ({
  value,
  data,
  changeSelected,
  setName,
  subsectionId,
  displayKey = 'Description',
  initialOpen = false,
  requiredAddons = [],
}) => {
  const [uiState, setUiState] = useState(initialOpen)
  useEffect(() => {
    if (initialOpen) {
      setUiState(true)
    }
  }, [initialOpen])

  const toggleUiState = () => setUiState(!uiState)

  const buttonClasses = classnames('refi-app__section-header__button', {
    'refi-app__section-header__button--open': uiState,
  })

  const sectionClass = classnames('', {
    'refi-app__section--open': uiState,
  })

  const isSelectedOneOfMany = (possibleValues, currentValue) => {
    return possibleValues.includes(currentValue['SurchargeCode'])
  }

  return (
    <div className={sectionClass}>
      <div
        className="refi-app__section-header"
        onClick={() => toggleUiState()}
        data-testid="coverage-sub-list-accordian"
      >
        <p className="coverage__sub-header coverage__sub-header--blue">
          {setName('SurchargeCode' ? value['SurchargeCode'] : '')}
        </p>
        <button className={buttonClasses}>Toggle</button>
        <hr className="form__hr" />
      </div>

      {uiState && (
        <div className="refi-payment-options__section">
          <div className="refi-payment-options__radio-buttons-group">
            {data && data.length > 0 && (
              <>
                {data.map((val) => {
                  const code = val.SurchargeCode
                  const isRequired =
                    Array.isArray(requiredAddons) &&
                    requiredAddons.includes(code as never)
                  return (
                    <CoverageProtectionCheckBox
                      value={val[displayKey]}
                      changeSelected={() => changeSelected(val)}
                      selected={isSelectedOneOfMany(value, val)}
                      disabled={isRequired}
                      key={val[displayKey]}
                      subsectionId={subsectionId}
                    />
                  )
                })}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default CoverageSurchargeFilterList
